import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { ProjetIndicateurService } from '../../plananalytique/programme/projet-indicateur/projet-indicateur.component';
import { Router } from '@angular/router';
import * as FileSaver from 'file-saver';


@Component({
  selector: 'app-evaluation-pta',
  standalone: false,
  templateUrl: './evaluation-pta.component.html',
  styleUrl: './evaluation-pta.component.scss'
})

export class EvaluationPtaComponent {

  annee: any;
  items: any[] = [];
  user: any;
  directionItems: any[] = [];
  directionId: any;
  isLoading: boolean = false;
  dateFin: any;
  dateDebut: any;

  // Suivi de l'état déplié/replié
  // expandedProgrammes[pi] = true/false
  expandedProgrammes: { [pi: number]: boolean } = {};
  // expandedActions[pi_ai] = true/false  (clé composite : "pi_ai")
  expandedActions: { [key: string]: boolean } = {};

  constructor(
    private modalService: NgbModal,
    private paramservice: ParameterService,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private projetService: ProjetIndicateurService,
    private ngxService: NgxUiLoaderService,
    private router: Router
  ) {
    this.annee = this.localstorage.getExerciceToUserToSuivieEvaluation();
    const exercice = this.localstorage.getExerciceToUserToSuivieEvaluation();
    this.dateDebut = `${exercice}-01-01`;
    this.dateFin = new Date().toISOString().split('T')[0];
  }

  ngOnInit() {
    this.user = this.localstorage.getInfoUserToService()?.data;
    this.directionId = this.user?.service?.direction?.reference;
    this.getStatistique();
    this.getDirection();
  }

  // ─── Déplier / Replier ─────────────────────────────────────────────────────

  toggleProgramme(pi: number): void {
    this.expandedProgrammes[pi] = !this.expandedProgrammes[pi];
  }

  toggleAction(pi: number, ai: number): void {
    const key = `${pi}_${ai}`;
    this.expandedActions[key] = !this.expandedActions[key];
  }

  isActionExpanded(pi: number, ai: number): boolean {
    return !!this.expandedActions[`${pi}_${ai}`];
  }

  /** Déplier tous les programmes et toutes les actions */
  expandAll(): void {
    this.items.forEach((progItem, pi) => {
      this.expandedProgrammes[pi] = true;
      (progItem.actions || []).forEach((_: any, ai: number) => {
        this.expandedActions[`${pi}_${ai}`] = true;
      });
    });
  }

  /** Replier tous les programmes et toutes les actions */
  collapseAll(): void {
    this.expandedProgrammes = {};
    this.expandedActions = {};
  }

  // ─── Données ────────────────────────────────────────────────────────────────

  getStatistique(): void {
    this.ngxService.start();
    this.isLoading = true;

    const requestData = {
      date_debut: this.dateDebut,
      date_fin: this.dateFin,
      user_reference: this.user.reference,
      type_operation: 'data'
    };

    this.paramservice.getStatistiqueEvaluationPta(requestData).subscribe(
      (response: any) => {
        this.ngxService.stop();
        this.isLoading = false;
        this.items = response.data.datas;

        // Réinitialiser l'état de déploiement après chaque rechargement
        this.expandedProgrammes = {};
        this.expandedActions = {};

        // Déplier le premier programme par défaut (optionnel)
        if (this.items.length > 0) {
          this.expandedProgrammes[0] = true;
        }
      },
      (error) => {
        this.ngxService.stop();
        this.isLoading = false;
        const errorMessage = this.extractErrorMessage(error);
        this.messageService.add({
          severity: 'error',
          summary: 'TEP',
          detail: errorMessage,
          life: 3000
        });
      }
    );
  }


  convertToNumber(value: any): number {
  if (value === null || value === undefined) return 0;
  return parseFloat(value.toString().replace(',', '.')) || 0;
}
  getDirection(): void {
    this.paramservice.fetchDataDirection().subscribe(
      (response: any) => {
        this.directionItems = response.data;
      },
      (error) => {
        console.error('Erreur chargement directions', error);
      }
    );
  }

  // ─── Export ─────────────────────────────────────────────────────────────────

  exportPtaDetail(): void {
    if (!this.dateDebut) {
      this.dateDebut = `${this.annee}-01-01`;
    }
    if (!this.dateFin) {
      this.dateFin = `${this.annee}-12-31`;
    }

    if (!this.dateDebut) {
      this.messageService.add({ severity: 'error', summary: 'PTA détail', detail: 'Veuillez renseigner la date de début', life: 3000 });
      return;
    }
    if (!this.dateFin) {
      this.messageService.add({ severity: 'error', summary: 'PTA détail', detail: 'Veuillez renseigner la date de fin', life: 3000 });
      return;
    }

    const requestData = {
      user_reference: this.user.reference,
      date_debut: this.dateDebut,
      date_fin: this.dateFin,
      type_operation: 'pdf'
    };

    this.ngxService.start();

    this.paramservice.getStatistiquePtaDetail(requestData).subscribe(
      (response: Blob) => {
        const blob = new Blob([response], { type: 'application/pdf' });
        window.open(URL.createObjectURL(blob), '_blank');
        this.ngxService.stop();
        this.messageService.add({
          severity: 'success',
          summary: 'Téléchargement réussi',
          detail: 'PTA détail PDF téléchargé',
          life: 3000
        });
      },
      (error) => {
        console.error('Erreur export PTA détail', error);
        const errorMessage = this.extractErrorMessage(error);
        this.messageService.add({ severity: 'error', summary: 'Erreur export PTA détail', detail: errorMessage, life: 3000 });
        this.ngxService.stop();
      }
    );
  }

  exportToDocument(typeDoc: string): void {
    if (!this.dateDebut) {
      this.dateDebut = `${this.annee}-01-01`;
    }
    if (!this.dateFin) {
      this.dateFin = `${this.annee}-12-31`;
    }

    if (!this.dateDebut) {
      this.messageService.add({ severity: 'error', summary: 'TEP', detail: 'Veuillez renseigner la date de début', life: 3000 });
      return;
    }
    if (!this.dateFin) {
      this.messageService.add({ severity: 'error', summary: 'TEP', detail: 'Veuillez renseigner la date de fin', life: 3000 });
      return;
    }

    const requestData = {
      date_debut: this.dateDebut,
      date_fin: this.dateFin,
      dirdection_id: this.directionId,
      user_reference: this.user.reference,
      type_operation: typeDoc
    };

    this.ngxService.start();

    this.paramservice.printStatistiqueGlobalPta(requestData).subscribe(
      (response: Blob) => {
        if (typeDoc === 'pdf') {
          const blob = new Blob([response], { type: 'application/pdf' });
          window.open(URL.createObjectURL(blob), '_blank');
        } else {
          const blob = new Blob([response], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          FileSaver.saveAs(blob, 'Statistiques_evaluation_pta.xlsx');
        }
        this.ngxService.stop();
        this.messageService.add({
          severity: 'success',
          summary: 'Téléchargement réussi',
          detail: `Fichier ${typeDoc.toUpperCase()} téléchargé`,
          life: 3000
        });
      },
      (error) => {
        console.error('Erreur export', error);
        const errorMessage = this.extractErrorMessage(error);
        this.messageService.add({ severity: 'error', summary: 'Erreur export', detail: errorMessage, life: 3000 });
        this.ngxService.stop();
      }
    );
  }

  // ─── Utilitaires ────────────────────────────────────────────────────────────

  private extractErrorMessage(error: any): string {
    if (!error) return 'Une erreur est survenue';
    if (error.error?.message) return error.error.message;
    if (error.message) return error.message;
    if (typeof error.error === 'string') {
      try {
        const parsed = JSON.parse(error.error);
        if (parsed.message) return parsed.message;
      } catch {
        return error.error;
      }
    }
    return 'Une erreur est survenue';
  }



  // Dans votre classe TepDirectionComponent, ajoutez ces méthodes :

// Calcul du total du montant budgétisé (somme des coûts des programmes)
getTotalMontantBudgetise(): number {
  if (!this.items || this.items.length === 0) return 0;
  
  return this.items.reduce((total, progItem) => {
    return total + (parseFloat(progItem.programme.cout) || 0);
  }, 0);
}

// Calcul du total engagé
getTotalEngage(): number {
  if (!this.items || this.items.length === 0) return 0;
  
  let total = 0;
  for (const progItem of this.items) {
    total += parseFloat(progItem.total_engage) || 0;
    if (progItem.actions) {
      for (const actionItem of progItem.actions) {
        total += parseFloat(actionItem.total_engage) || 0;
        if (actionItem.activites) {
          for (const activiteItem of actionItem.activites) {
            total += parseFloat(activiteItem.total_engage) || 0;
          }
        }
      }
    }
  }
  return total;
}

// Calcul du total ordonnancé
getTotalOrdonnance(): number {
  if (!this.items || this.items.length === 0) return 0;
  
  let total = 0;
  for (const progItem of this.items) {
    total += parseFloat(progItem.total_ordonnance) || 0;
    if (progItem.actions) {
      for (const actionItem of progItem.actions) {
        total += parseFloat(actionItem.total_ordonnance) || 0;
        if (actionItem.activites) {
          for (const activiteItem of actionItem.activites) {
            total += parseFloat(activiteItem.total_ordonnance) || 0;
          }
        }
      }
    }
  }
  return total;
}

// Calcul du total décaissé
getTotalDecaisse(): number {
  if (!this.items || this.items.length === 0) return 0;
  
  let total = 0;
  for (const progItem of this.items) {
    total += parseFloat(progItem.total_decaisse) || 0;
    if (progItem.actions) {
      for (const actionItem of progItem.actions) {
        total += parseFloat(actionItem.total_decaisse) || 0;
        if (actionItem.activites) {
          for (const activiteItem of actionItem.activites) {
            total += parseFloat(activiteItem.total_decaisse) || 0;
          }
        }
      }
    }
  }
  return total;
}

// Calcul du taux moyen pondéré
getTauxMoyenPondere(champ: string): number {
  if (!this.items || this.items.length === 0) return 0;
  
  let sommeTauxPondere = 0;
  let sommePoids = 0;
  
  const parcourirNiveaux = (element: any, poidsParent: number = 1) => {
    const taux = parseFloat(element[champ]) || 0;
    const poids = parseFloat(element.activite?.poids || element.action?.poids || element.programme?.poids || 1);
    
    sommeTauxPondere += taux * poids;
    sommePoids += poids;
    
    // Parcourir les enfants si existent
    if (element.actions) {
      for (const action of element.actions) {
        parcourirNiveaux(action, poids);
      }
    }
    if (element.activites) {
      for (const activite of element.activites) {
        const poidsActivite = parseFloat(activite.activite?.poids) || 1;
        const tauxActivite = parseFloat(activite[champ]) || 0;
        sommeTauxPondere += tauxActivite * poidsActivite;
        sommePoids += poidsActivite;
      }
    }
  };
  
  for (const progItem of this.items) {
    parcourirNiveaux(progItem);
  }
  
  return sommePoids > 0 ? sommeTauxPondere / sommePoids : 0;
}

// Version alternative plus simple pour les totaux au niveau programme uniquement
getTauxMoyenPondereSimple(champ: string): number {
  if (!this.items || this.items.length === 0) return 0;
  
  let sommeMontants = 0;
  let sommeTauxPondere = 0;
  
  for (const progItem of this.items) {
    const montant = parseFloat(progItem.programme.cout) || 0;
    const taux = parseFloat(progItem[champ]) || 0;
    
    sommeMontants += montant;
    sommeTauxPondere += taux * montant;
  }
  
  return sommeMontants > 0 ? sommeTauxPondere / sommeMontants : 0;
}
}